<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import IdSearchHeader from '@/components/ui/IdSearchHeader.vue';
import FundingSourceDetailPanel from '@/components/funding-sources/FundingSourceDetailPanel.vue';
import { useFundingSourceSearches } from '@/components/funding-sources/fundingSourceSearches';
import { FundingSourceActions } from '@/integrations/Immersve/auth/actions';

const route = useRoute();
const searches = useFundingSourceSearches();

const fundingSourceId = computed(() => route.params.fundingSourceId as string);
</script>

<template>
  <SidebarLayout>
    <!-- The funding source's account is unknown until it is loaded, so
    funding-source:read is asked for on any account; amethyst checks it against
    the funding source's own. -->
    <SecurityTrim :actions="[FundingSourceActions.Read]" account-id="*">
      <div class="px-4 py-6 md:px-8" data-test="screen-funding-source">
        <IdSearchHeader :searches="searches" />
        <FundingSourceDetailPanel :funding-source-id="fundingSourceId" />
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
